import React, { memo } from 'react';
import { NgBootstrap } from './loaders';

export const NgErrorApp = memo(() => {
  // The EventController.EventPage dotnet action returns different cshtml depending
  // on the Marketplace.EventTheme value from the database.
  // We're using a simple dom query to see which cshtml we have to load the correct
  // angularjs module.
  // @ts-ignore
  return <NgBootstrap entrypoint={() => import('../../../src/OCS.Web/wwwroot/app/errorApp')} />;
});
